export default "__VITE_ASSET__5uyfd6Va__"